import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'timezoneDate',
  standalone: false
})
export class TimezoneDatePipe implements PipeTransform {
  transform(
    value: string | Date,
    timezone: string,
    type: 'date' | 'time' | 'datetime' = 'datetime'
  ): string {
    if (!value || !timezone) return '';

    // Ensure moment-timezone is applied
    const date = moment.tz(value, timezone);

    switch (type) {
      case 'date':
        return date.format('MM/DD/YYYY');
      case 'time':
        return date.format('hh:mm A');
      case 'datetime':
      default:
        return date.format('MM/DD/YYYY hh:mm A');
    }
  }
}
